import IntlMessages from "@lib/helpers/IntlMessages";
import { StyledNoUserScreen } from "../index.styled";
import { AiOutlineMessage } from "react-icons/ai";

const NoUserScreen = () => {
  return (
    <StyledNoUserScreen>
      <AiOutlineMessage />
      <p className="mb-0">
        <IntlMessages id="common.noUser" />
      </p>
    </StyledNoUserScreen>
  );
};

export default NoUserScreen;
